import { createContext } from 'react';

const ActionDialogContext = createContext();

export default ActionDialogContext;
